import { twMerge } from 'tailwind-merge';
import { InputHTMLAttributes } from 'react';

type InputProps = {
    invalid?: boolean
} & InputHTMLAttributes<HTMLInputElement>

export const Input = ({invalid, disabled, ...rest}: InputProps) => {
    return (
        <input
            {...rest}
            disabled={disabled}
            className={twMerge(
                'form-input block w-full rounded-lg border border-surface-3 bg-surface-3 p-2.5 text-on-surface outline-hidden focus:outline-hidden transition-colors hover:bg-surface-5 focus:border-primary focus:bg-surface-5 focus:ring-primary focus-visible:ring-primary',
                disabled && 'cursor-not-allowed bg-surface-1 hover:bg-surface-1',
                invalid && 'border-error focus:border-error focus-visible:ring-error'
            )}
        />
    )
}
